import { createContext } from 'react'

export type ChatColorTheme = 'light' | 'dark' | 'transparent'
export interface ChatThemeContextState {
  theme: ChatColorTheme
}

export const ChatThemeContext = createContext<ChatThemeContextState>({
  theme: 'light',
})
